import React from 'react'
import styled from 'styled-components'
import { LargeWrapper } from '@raysync/common/components'
import { Devices } from '@raysync/common/theme'
import { Title, Desc } from '../atoms'
const Section = styled(LargeWrapper)`
  padding: 80px 0 116px;
  @media ${Devices.phone} {
    padding-top: 0.8rem;
    padding-bottom: 1rem;
  }
`

const List = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  flex-wrap: wrap;
`

const Item = styled.div`
  display: flex;
  width: 100%;
  margin-top: 94px;
  justify-content: space-between;
  align-items: center;
  svg {
    width: 640px;
  }
  &:nth-child(even) {
    flex-direction: row-reverse;
  }
  @media ${Devices.phone} {
    margin-top: 0.2rem;
    flex-wrap: wrap;
    justify-content: unset;
    align-items: unset;
    flex-direction: unset !important;
    svg {
      width: 100%;
      margin-top: 0.6rem;
    }
  }
`

const ContentBox = styled.div`
  max-width: 620px;
  h3 {
    font-size: 30px;
    font-weight: bold;
    color: ${p => p.theme.color.textDarkPlus};
    line-height: 40px;
    margin-bottom: 14px;
  }
  ul {
    list-style: none;
    padding-left: 6px;
    color: #788296;
    li {
      padding-left: 6px;
      font-size: 16px;
      line-height: 1.5;
      &::marker {
        content: '•';
        display: block;
      }
    }
  }
  @media ${Devices.phone} {
    max-width: unset;
    margin-top: 0.4rem;
    h3 {
      font-size: 0.36rem;
      line-height: 1.2;
      margin-bottom: 0.2rem;
    }
    ul {
      li {
        font-size: 0.2rem;
      }
    }
  }
`

const Advantages = ({ title, desc, items }) => {
  return (
    <Section>
      <Title>{title}</Title>
      <Desc>{desc}</Desc>
      {items && (
        <List>
          {items.map((item, index) => (
            <Item key={index}>
              <ContentBox>
                <h3>{item.title}</h3>
                <ul>{item.desc}</ul>
              </ContentBox>
              {item.svg}
            </Item>
          ))}
        </List>
      )}
    </Section>
  )
}

export default Advantages
